import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthProvider';
import Loader from './Loader';

export default function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader label="" />;
  return user ? children : <Navigate to="/login" replace />;
}
